module.exports = "/packs/images/svg/accessibility/lift~acc6e934808a1526c698a83db4ed65b5.svg";